export default __webpack_public_path__ + "assets/json/000c78d66b5aa8a4bfee3e2895cc32b7.json";